import React, { Fragment, memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, func, node, number, shape, string } from 'prop-types'

import useGridColumns from 'Pods/ThreeDStudio/Components/ImageAssistantPanel/Hooks/useGridColumns'

import ExpandedImage from '../ExpandedImage/ExpandedImage'

function ImageGrid({
  images, selectedImage = null, header = null, onSelectImage, onClose, onApply, onEdit,
}) {
  const columns = useGridColumns()
  const selectedIndex = selectedImage ? images.findIndex(image => image.id === selectedImage.id) : -1
  // Insert the full-width preview right after the row that holds the selected image.
  const insertAfter = selectedIndex >= 0
    ? Math.min((Math.floor(selectedIndex / columns) + 1) * columns - 1, images.length - 1)
    : -1

  return (
    <div className="image-assistant-panel__section">
      {header}
      <div className="image-assistant-panel__grid">
        {images.map((image, index) => (
          <Fragment key={image.id}>
            <button
              type="button"
              className={classnames(
                'image-assistant-panel__card',
                'image-assistant-panel__card--image',
                image.id === selectedImage?.id && 'image-assistant-panel__card--selected',
              )}
              onClick={() => onSelectImage(image)}
            >
              <img
                className="image-assistant-panel__card-image"
                src={image.url}
                alt={image.alt}
                loading="lazy"
                decoding="async"
              />
            </button>
            {index === insertAfter && (
              <ExpandedImage
                image={selectedImage}
                onClose={onClose}
                onApply={onApply}
                onEdit={onEdit}
              />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}

ImageGrid.propTypes = {
  images: arrayOf(shape({
    id: number.isRequired,
    url: string.isRequired,
    alt: string,
  })).isRequired,
  selectedImage: shape({ id: number }),
  header: node,
  onSelectImage: func.isRequired,
  onClose: func.isRequired,
  onApply: func.isRequired,
  onEdit: func.isRequired,
}

export default memo(ImageGrid)
